import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { supportApi } from '../../services/supportApi';

interface Props {
  children: React.ReactNode;
  /** Inside the support-only shell: say so when refused, instead of redirecting (a redirect would loop). */
  staff?: boolean;
}

/**
 * Lets staff and admins into the Support Desk. The backend decides: the status
 * probe answers 200 only for a support user or an admin while the desk is on
 * (403 for an advocate, 503 when switched off).
 */
const SupportRoute: React.FC<Props> = ({ children, staff = false }) => {
  const [allowed, setAllowed] = useState<boolean | null>(null);

  useEffect(() => {
    let live = true;
    supportApi
      .status()
      .then(() => live && setAllowed(true))
      .catch(() => live && setAllowed(false));
    return () => {
      live = false;
    };
  }, []);

  if (allowed === null) {
    return <div className="min-h-[40vh] grid place-items-center text-slate-500 text-sm">Loading…</div>;
  }
  if (!allowed) {
    return staff ? (
      <div className="max-w-md mx-auto py-20 px-4 text-center text-slate-600">
        The Support Desk is switched off right now. Please try again later.
      </div>
    ) : (
      <Navigate to="/" replace />
    );
  }
  return <>{children}</>;
};

export default SupportRoute;
